/*
 * v-safe-html — Vue 2 directive that renders sanitised HTML.
 * Drops <script>, event handlers, javascript: URIs, and other XSS vectors
 * via DOMPurify. See src/lib/sanitiseHtml.js for the allowlist.
 *
 * Use exactly like v-html:
 *   <span v-safe-html="userContent" />
 */
import { sanitiseHtml } from '@/lib/sanitiseHtml'

function setSafeHtml (el, binding) {
  el.innerHTML = sanitiseHtml(binding.value)
}

export default {
  bind: setSafeHtml,
  update: setSafeHtml
}
